import { IGNORED_BUGSNAG_ERRORS } from './ignoredErrors';

const matchesStringOrRegex = (value, pattern) => {
    if (pattern instanceof RegExp) return pattern.test(value);
    return value === pattern;
};

const includesAny = (haystack, needles) => needles.some((needle) => haystack.includes(needle));

const getStackText = (stacktrace = []) =>
    stacktrace
        .flatMap((frame) => [frame.file, frame.method])
        .filter(Boolean)
        .join('\n');

const matchesRule = (error, rule) => {
    if (rule.errorClass && !matchesStringOrRegex(error.errorClass, rule.errorClass)) {
        return false;
    }

    if (rule.message && !matchesStringOrRegex(error.errorMessage, rule.message)) {
        return false;
    }

    if (rule.stackIncludes) {
        const needles = Array.isArray(rule.stackIncludes)
            ? rule.stackIncludes
            : [rule.stackIncludes];
        if (!includesAny(getStackText(error.stacktrace), needles)) {
            return false;
        }
    }

    return true;
};

export const shouldDiscardBugsnagEvent = (event) => {
    const error = event.errors?.[0];
    if (!error) return false;

    return IGNORED_BUGSNAG_ERRORS.some((rule) => matchesRule(error, rule));
};
